import { useState } from '@wordpress/element';
import { AREA_LABELS, AREA_TO_SECTION_ID } from '../../constants/areaMappings';
import FieldRenderer from '../fields/FieldRenderer';
import AddElementButton from './AddElementButton';

const AreaRenderer = ({ 
  area, 
  sections, 
  onOpenModal, 
  onEditField, 
  onDeleteField,
  onMoveFieldUp,
  onMoveFieldDown,
  variant = 'default',
  mode = 'edit'
}) => {
  const sectionId = AREA_TO_SECTION_ID[area];
  const section = sections.find(s => s.id === sectionId);
  const label = AREA_LABELS[area];
  const [activeMoveId, setActiveMoveId] = useState(null);
  
  // Check if this area has any fields
  const hasFields = section?.fields && section.fields.length > 0;
  
  const getAreaStyles = () => {
    const baseStyles = {};
    
    if (area === 'thumbnail') {
      baseStyles.minHeight = '80px';
      baseStyles.minWidth = '65px';
    } else if (area === 'avatar') {
      baseStyles.minHeight = '70px';
    } else {
      baseStyles.minHeight = '30px';
    }
    
    return baseStyles;
  };

  // Handle move up with active state
  const handleMoveUp = (fieldId, event) => {
    setActiveMoveId(fieldId);
    onMoveFieldUp(fieldId, event);
    setTimeout(() => setActiveMoveId(null), 300);
  };

  // Handle move down with active state
  const handleMoveDown = (fieldId, event) => {
    setActiveMoveId(fieldId);
    onMoveFieldDown(fieldId, event);
    setTimeout(() => setActiveMoveId(null), 300);
  };

  // Render default avatar icon when no fields exist
  const renderDefaultAvatar = () => {
    if (area === 'avatar' && !hasFields && mode === 'edit') {
      return (
        <div className="hvnly--builder---api_property__builder___default_avatar_icon">
          <i className="fas fa-user"></i>
        </div>
      );
    }
    return null;
  };

  return (
    <div 
      className={`hvnly--builder---api_property__builder___editable_area ${variant} ${area}-area ${!hasFields ? 'empty' : ''}`} 
      style={getAreaStyles()}
    >
      {mode === 'edit' && (
        <AddElementButton onClick={(e) => onOpenModal(area, e)} />
      )}
      
      {/* Default avatar icon */}
      {renderDefaultAvatar()}
      
      {section?.fields.map((field, index) => (
        <FieldRenderer
          key={field.id}
          field={field}
          onEdit={onEditField}
          onDelete={onDeleteField}
          onMoveUp={handleMoveUp}
          onMoveDown={handleMoveDown}
          canMoveUp={index > 0}
          canMoveDown={index < section.fields.length - 1}
          isMoving={activeMoveId === field.id}
          mode={mode}
          area={area}
        />
      ))}
    </div>
  );
};

export default AreaRenderer;